/**
 * Privacy API functions
 * Requirements: 10.1, 10.2 - Data export and account deletion
 */
import { createAuthenticatedClient } from '../../../shared/api/axiosClient';
import type { UserDataExport } from '../types/privacy.types';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

const getClient = () => {
  return createAuthenticatedClient(API_BASE_URL, () => {
    window.location.href = '/login';
  });
};

/**
 * Export user data in JSON format
 * Requirements: 10.1 - Data export in JSON format
 */
export const exportUserData = async (): Promise<UserDataExport> => {
  const client = getClient();
  const response = await client.get<UserDataExport>('/privacy/export');
  return response.data;
};

/**
 * Delete user account and all associated data
 * Requirements: 10.2 - Account deletion with confirmation
 */
export const deleteAccount = async (): Promise<{ success: boolean }> => {
  const client = getClient();
  const response = await client.delete<{ success: boolean }>('/privacy/account');
  return response.data;
};
